import i18next from 'i18next';
import { setCallTimeout } from '../../../core/functions/timeoutManager';

const handleNoConnection = (callDispatch, notificationDispatch, data) => {
  const { placeId, pointId, userId, userDevice } = data;
  setCallTimeout(
    'initiated',
    userId,
    () => {
      const date = new Date().getTime();
      const message = i18next.t('calls.NOTIFICATIONS.unreachable');
      const newNotification = new CustomEvent('Notification', {
        detail: { message, type: 'danger' },
      });
      window.dispatchEvent(newNotification);
      notificationDispatch({
        type: 'ADD_NOTIFICATION',
        payload: {
          notificationId: 'call',
          message,
          placeId,
          pointId,
          userId,
          type: 'danger',
          date,
        },
      });
      callDispatch({
        type: 'CALL_NOT_RECEIVED',
        payload: { placeId, userId, pointId, userDevice },
      });
    },
    3000,
  );
};

export const initiateCall = async (data, reducers, WSConnection) => {
  const { placeId, pointId, userId, userDevice, details } = data;
  const { callDispatch, notificationDispatch } = reducers;
  const payload = { placeId, userId, pointId, userDevice, details };

  callDispatch({
    type: 'INITIATE_CALL',
    payload,
  });

  const newCall = JSON.stringify({
    type: 'CALL_NEW',
    payload,
  });

  try {
    await WSConnection.send(newCall);
  } catch (error) {
    handleNoConnection(callDispatch, notificationDispatch, data);
    return;
  }
};
